module.exports = __webpack_public_path__ + "img/poster-drop.a27dfe45.jpg";